import * as React from 'react';
import useHttpClient, { headers } from './useHttpClient';

interface StructuredAddress {
  fullAddress?: string;
  country: string;
  buildingName: '';
  streetAddress1: string;
  city: string;
  stateCode: string;
  postalCode: string;
  gnaf: string;
}

export const useStructuredAddress = () => {
  const [addressData, setAddressData] = React.useState<StructuredAddress | null>(null);
  const [{ error }, getAddress] = useHttpClient(
    {
      url: 'x-digital-remediation-qbe-anzo/api/v1/addresses/structured-address',
    },
    { manual: true }
  );

  const getAddressData = async (moniker: string | undefined): Promise<StructuredAddress | null> => {
    try {
      const response = await getAddress({
        method: 'GET',
        params: { moniker },
        headers,
      });

      setAddressData(response.data);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  return { getAddressData, error, addressData };
};
